// extracted by mini-css-extract-plugin
export default {"container":"Header_container__AmA4F","logoSection":"Header_logoSection__Se0kX"};